<template>
  <div>
    <v-layout row wrap class="ma-0 pa-0">
      <v-flex xs8>
        <v-tabs @change="onChangeTab" v-model="tabvalue" slider-color="primary">
          <v-tab ripple href="#imeiList" value="imeiList"> Imei </v-tab>
          <v-tab ripple href="#campaignList" value="campaignList"> Campaign </v-tab>
        </v-tabs>
      </v-flex>
      <v-flex xs4>
        <div class="text-xs-right">
          <v-btn icon @click="$emit('close')">
            <v-icon>close</v-icon>
          </v-btn>
        </div></v-flex
      >
    </v-layout>

    <div class="pa-3">
      <div style="display: flex; justify-content: space-between">
        <div>
          <v-pagination
            :total-visible="15"
            v-model="pageNumber"
            @input="changePage"
            :length="pagelength"
          ></v-pagination>
        </div>
        <div>
          <v-btn @click="showCreateDialog = true" color="primary">เพิ่ม Coin</v-btn>
        </div>
      </div>

      <v-data-table
        :headers="headers[tabvalue]"
        :items="filteredItems"
        :loading="loading"
        hide-actions
        :pagination.sync="pagination"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <tr>
            <template v-if="tabvalue == 'imeiList'">
              <td>{{ props.item.imei }}</td>
              <td>
                {{ props.item.description }}
              </td>
            </template>
            <template v-else>
              <td>{{ props.item.campaign }}</td>
            </template>
            <td>
              {{ props.item.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}
            </td>

            <td>
              <span style="font-size: 19px; font-weight: bold">
                {{ numberFormat(props.item.points) }}
              </span>
              Coin
            </td>

            <td class="text-xs-right">
              <v-btn @click="showEdit(props.item)" icon>
                <v-icon color="primary">edit</v-icon></v-btn
              >
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
    <v-dialog v-model="showEditDialog" width="300px" persistent>
      <v-card>
        <div class="text-xs-right">
          <v-btn @click="cancelEdit" icon><v-icon color="primary">close</v-icon></v-btn>
        </div>
        <div class="form-control pa-1" :class="{ 'has-error': errors.has('Points') }">
          <input
            :data-vv-as="$t('Points')"
            v-validate="'required'"
            v-model="input.points"
            class="form-control"
            type="number"
            name="Points"
          />
          <span class="text-error" v-if="errors.has('Points')">{{ errors.first('Points') }}</span>
        </div>
        <div class="text-xs-center">
          <v-btn @click="cancelEdit" outline color="grey">cancel</v-btn>
          <v-btn @click="updatePoints" :loading="editloading" depressed color="primary">save</v-btn>
        </div>
      </v-card>
    </v-dialog>
    <div class="overflow-visible-dialog">
      <v-dialog
        content-class="overflow-visible-dialog"
        style="overflow: visible !important"
        v-model="showCreateDialog"
        width="500px"
        persistent
      >
        <v-card v-if="showCreateDialog">
          <MemberPointDetailCreate
            @onsavecreate="onsavecreate"
            @close="showCreateDialog = false"
            :datavalue="datavalue"
          ></MemberPointDetailCreate>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import Multipleselect from 'vue-multiselect'
import MemberPointDetailCreate from './MemberPointDetailCreate.vue'
export default {
  components: {
    Multipleselect,
    MemberPointDetailCreate
  },
  props: ['datavalue'],
  data() {
    return {
      tabvalue: 'imeiList',
      showCreateDialog: false,
      editloading: false,
      saveloading: false,
      input: {
        points: 0
      },
      createdata: '',
      pagination: { rowsPerPage: -1, sortBy: '' },
      editingItems: [],
      loading: false,
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      editdata: '',
      showEditDialog: false,
      data: [],
      headers: {
        imeiList: [
          { text: 'เลข IMEI', value: 'imei' },
          { text: 'ข้อมูลเครื่อง', value: 'description' },
          { text: 'วัน&เวลา', value: 'timestamp' },
          { text: 'Coin ที่ได้รับ', value: 'points' },
          { text: '', value: '' }
        ],
        campaignList: [
          { text: 'แคมเปญ', value: 'campaign' },
          { text: 'วัน&เวลา', value: 'timestamp' },
          { text: 'Coin ที่ได้รับ', value: 'points' },
          { text: '', value: '' }
        ]
      }
    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    filteredItems() {
      // if(this.tabvalue=='imeiList') {
      //   return this.data.imeiList
      // } else {
      //   return this.data.campaignList
      // }

      return this.data[0][this.tabvalue]
    },
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / this.limit)
      } else {
        return 1
      }
    },
    ...mapGetters(['selectedBot'])
  },
  methods: {
    onChangeTab(item) {
      this.total = 0
      this.offset = 0
      this.pagetmp = 1
      this.pageNumber = 1
      this.getData()
    },
    onsavecreate() {
      this.getData()
      this.cancelCreate()
      this.$emit('onsavecreate')
    },

    cancelCreate() {
      this.showCreateDialog = false
    },
    cancelEdit() {
      this.showEditDialog = false
    },
    showEdit(item) {
      this.input.points = item.points
      this.editdata = item
      this.showEditDialog = true
    },
    //   updateYasaleImei
    async updatePoints() {
      if (await this.$validator.validate()) {
        var data = {
          pageid: this.selectedBot.pageid,
          imei: this.editdata.imei,
          description: this.editdata.description,
          points: this.input.points
        }
        this.editloading = true
        api.updateYasaleImei(data, (err, response) => {
          this.editloading = false
          this.showEditDialog = false
          if (response.responsecode == 200) {
            var index = this.data.findIndex((el) => el.imei == this.editdata.imei)
            this.data[index].points = this.input.points
          }
        })
      }
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getData()
      }
    },
    getData() {
      var data = {
        pageid: this.selectedBot.pageid,
        memberId: this.datavalue.id,
        limit: this.limit,
        offset: this.offset
      }
      this.loading = true
      api.getYasaleMemberPoint(data, (err, response) => {
        this.loading = false
        if (response.responsecode == 200) {
          this.data = response.data
          if (this.tabvalue == 'imeiList') {
            this.total = response.imeiTotal
          } else {
            this.total = response.campaignTotal
          }
        }
      })
    }
  }
}
</script>

<style lang="scss">
.overflow-visible-dialog {
  overflow: visible !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/yasale/member/MemberPointDetail.vue